/** Stable key so we do not call setState when ReactGrid row model content is unchanged. */
export default function derivedRowsSyncKey(
  rows:
    | {
        rowId?: string | number;
        id?: string | number;
        cells?: { isLoading?: boolean; text?: string | number | null }[];
      }[]
    | undefined,
): string {
  if (!rows?.length) {
    return '0';
  }
  const loadingCount = rows.reduce(
    (count, row) => count + (row?.cells?.some((cell) => cell?.isLoading) ? 1 : 0),
    0,
  );
  // Include cell text so value-only V2 refetches (formula submit, put) still
  // sync into ReactGrid state — row ids alone stay identical in those cases.
  return `${rows.length}:${loadingCount}:${rows
    .map((row) => {
      const id = row?.rowId ?? row?.id ?? '';
      const texts =
        row?.cells?.map((cell) => (cell?.isLoading ? '~' : String(cell?.text ?? ''))).join(',') ??
        '';
      return `${id}@${texts}`;
    })
    .join('|')}`;
}
